import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { Screens } from '../screens';
import { useTranslation } from 'react-i18next';
import PatientUpdateStackParamsList from './ParamsList';
import PatientProfileUpdate from 'src/scenes/PatientProfileUpdate';
import PatientSelector from 'src/scenes/PatientSelector';
import ExitProvider from 'src/providers/ExitProvider';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import { fontStyles } from 'src/theme/globalStyles';
import { fonts, Weight } from 'src/theme';
import styled from 'styled-components/native';
import { SIDEBAR_WIDTH } from 'src/module/FormKit/components/constants';
import { Margin } from 'src/constants';
import { ChevronLeft } from 'react-native-feather';
import { HoverButton } from 'src/components';

const PatientUpdateStack = createStackNavigator<PatientUpdateStackParamsList>();

export const PatientUpdateStackNavigator: React.FC = () => {
  const { t } = useTranslation('requests');
  const { colors } = useAppTheme();

  return (
    <InnerView>
      <ExitProvider>
        <PatientUpdateStack.Navigator>
          <PatientUpdateStack.Group
            screenOptions={{
              headerStyle: {
                backgroundColor: colors.background,
                borderBottomWidth: 0.5,
                borderBottomColor: colors.disabled
              },
              headerTitleStyle: {
                ...fontStyles.body,
                fontWeight: Weight.MEDIUM,
                fontFamily: fonts.roboto.medium
              },
              headerTintColor: colors.text
            }}
          >
            <PatientUpdateStack.Screen
              name={Screens.REQUESTS_PATIENT_SELECTOR}
              component={PatientSelector}
              options={{
                title: t('requests:wizard.whichPet'),
                headerLeft: () => <BackButton />
              }}
            />
            <PatientUpdateStack.Screen
              name={Screens.PATIENT_PROFILE_UPDATE}
              component={PatientProfileUpdate}
              options={{
                title: t('informationUpdate:editing')
              }}
            />
          </PatientUpdateStack.Group>
        </PatientUpdateStack.Navigator>
      </ExitProvider>
    </InnerView>
  );
};

const BackButton = styled(HoverButton).attrs({
  icon: ChevronLeft,
  mode: 'contained'
})`
  padding: ${Margin.Small}px;
  border-radius: ${Margin.ExtraLarge}px;
  flex-shrink: 0;
`;

const InnerView = styled.View`
  flex: 1;
  margin: ${({ theme }) => (theme.viewMode.isMobile ? `0px` : `${Margin.ExtraLarge}px`)};
  max-width: ${({ theme }) =>
    theme.viewMode.isMobile ? '100%' : `${SIDEBAR_WIDTH + theme.viewMode.maxContentWidth}px`};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};

  border-top-left-radius: ${({ theme }) => theme.roundness}px;
  border-top-right-radius: ${({ theme }) => theme.roundness}px;
  ${({ theme }) => !theme.viewMode.isMobile && `border-bottom-left-radius: ${theme.roundness}px;`}
  ${({ theme }) => !theme.viewMode.isMobile && `border-bottom-right-radius: ${theme.roundness}px;`}
  overflow: hidden;

  align-self: center;
`;
